<template lang="pug">
div.white.round-lg.pa-8(:style="width")
  v-card.border.round-lg(outlined)
    .pa-4.clinic-name-height
      .d-flex.justify-space-between.mb-2
        .text-sm.font-bold CLINIC NAME
        .text-sm.font-bold(v-if="phone") Tel: (019-XXXXXXXX)
      .text-sm.text-left(v-if="address") Mockup address 2-A, Persiaran Kinci, 43000 Kajang, Selangor
    v-divider.neutral700
    .pa-4.medication-height
      .d-flex.justify-space-between.mb-1
        .text-md.font-bold Paracetamol Tablet 500mg.
        .text-md.font-bold(v-if="quantity") QTY: 10 Tab/s
      .d-flex.justify-space-between.mb-2
        .text-sm.text-left 1 BIJI, 3 KALI SEHARI, SELEPAS MAKAN.
        .text-sm.text-right.font-bold(v-if="expiryDate") EXP: 31/3/2026
      template(v-if="precaution")
        .text-sm.text-left Precaution: This drug may cause drowsiness. Swallow whole, do not chew/crush
      template(v-if="duration")
        .text-sm.text-left Duration: Stop after 2 weeks of consumption
      template(v-if="indication")
        .text-sm.text-left Indication: Fever & Pain Killer
    v-divider.neutral700
    .pa-4
      .d-flex.justify-space-between.mb-1
        .text-sm.text-left.font-bold Ali Asgard, Male, 36 years old
        .text-sm.text-right(v-if="date") Date: 31/3/2023
</template>

<script>
export default {
  props: {
    address: {
      type: Boolean
    },
    phone: {
      type: Boolean
    },
    quantity: {
      type: Boolean
    },
    precaution: {
      type: Boolean
    },
    date: {
      type: Boolean
    },
    expiryDate: {
      type: Boolean
    },
    duration: {
      type: Boolean
    },
    indication: {
      type: Boolean
    },
  },
  computed: {
    width () {
      const value = this.$vuetify.breakpoint.xl ? '30vw' : '90%'
      return `width:${value}`
    },
  },
}
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid var(--v-neutral700) !important;
}
.clinic-name-height {
  height: 75px;
}
.medication-height {
  height: 170px;
}
</style>